import { render, staticRenderFns } from "./DomainSummaryStatsCard.vue?vue&type=template&id=86152e28&scoped=true"
import script from "./DomainSummaryStatsCard.vue?vue&type=script&lang=js"
export * from "./DomainSummaryStatsCard.vue?vue&type=script&lang=js"
import style0 from "./DomainSummaryStatsCard.vue?vue&type=style&index=0&id=86152e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86152e28",
  null
  
)

export default component.exports